import { Crown, Handshake, Swords, Compass, HeartPulse, Sparkles, Shuffle } from "lucide-react";

export const ROLE_ICONS = {
  captain: Crown,
  rightHand: Handshake,
  combat: Swords,
  navigation: Compass,
  support: HeartPulse,
  specialist: Sparkles,
  jolly: Shuffle,
};

export const ROLE_COLORS = {
  captain: "#FFD166",
  rightHand: "#A989FF",
  combat: "#F26DB5",
  navigation: "#55D7F3",
  support: "#A989FF",
  specialist: "#F26DB5",
  jolly: "#55D7F3",
};

// Darker role tones for text/icons on light surfaces (WCAG-friendly on white).
export const ROLE_INK = {
  captain: "#8A5D00",
  rightHand: "#7433C1",
  combat: "#B0388F",
  navigation: "#137490",
  support: "#7433C1",
  specialist: "#B0388F",
  jolly: "#137490",
};
